import { styled } from "@mui/material";
import { IPropsForm } from "../../types/components";

const FormStyled = styled('form')({
    flexGrow: 2,
    zIndex: 1,
    minHeight: '100h',
    display: 'flex',
    flexDirection: 'column',
    padding: '25px 0px',
})

const Form = ({ children, props }: IPropsForm) => {
    return (
        <FormStyled {...props} >
            {children}
        </FormStyled>
    )
}

export default Form;